import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import { ContentObjectTypes, useContentObjectType } from 'content-management-data-lib';
import { Text } from 'foundations-components/components/Text';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import http from 'hub-http/clients/apiClient';
import { getDetailsUrl } from 'page-lib/utils/urls';
import { useState } from 'react';
import { usageTracker } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const requestEndMABTest = ({
  contentObjectType,
  mabExperimentId,
  winnerId
}) => {
  return http.post(`cospages/v2/${contentObjectType === ContentObjectTypes.LANDING_PAGE ? 'landing' : 'site'}-pages/mab-end-experiment/${mabExperimentId}`, {
    data: {
      winnerId
    }
  });
};
const ModalDescription = ({
  mabMetric,
  setWinnerId,
  isMABEndTestLoading,
  variationsList
}) => {
  const metricLangKey = `page-details-ui.testResults.personalization.mabEndTestModal.metric.${mabMetric}`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.testResults.personalization.mabEndTestModal.descriptionLabel"
      })
    }), /*#__PURE__*/_jsx(ToggleGroup, {
      name: "variations",
      children: variationsList.map((variation, index) => /*#__PURE__*/_jsx(RadioInput, {
        defaultChecked: index === 0,
        description: variation.metricValue && /*#__PURE__*/_jsx(Text, {
          as: "small",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${metricLangKey}.${index === 0 ? 'leader' : 'default'}`,
            options: {
              value: Math.round(variation.metricValue * 10000) / 100
            }
          })
        }),
        onChange: () => setWinnerId(variation.id),
        paddingBlock: "200",
        children: variation.name
      }, variation.id))
    }), isMABEndTestLoading && /*#__PURE__*/_jsx(Overlay, {
      contextual: true,
      use: "light",
      width: 100,
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        layout: "centered",
        use: "danger"
      })
    })]
  });
};
const MABEndTestModal = ({
  onCloseModal,
  onEndTest,
  mabMetric,
  isMABEndTestLoading,
  variationsList
}) => {
  const [winnerId, setWinnerId] = useState(variationsList[0].id);
  return /*#__PURE__*/_jsx(ConfirmModal, {
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.testResults.personalization.mabEndTestModal.confirmLabel"
    }),
    confirmUse: "danger",
    description: /*#__PURE__*/_jsx(ModalDescription, {
      isMABEndTestLoading: isMABEndTestLoading,
      mabMetric: mabMetric,
      setWinnerId: setWinnerId,
      variationsList: variationsList
    }),
    match: I18n.text('page-details-ui.testResults.personalization.mabEndTestModal.matcherValue'),
    matcherLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.testResults.personalization.mabEndTestModal.matcherLabel"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.testResults.personalization.mabEndTestModal.message"
    }),
    onConfirm: () => onEndTest(winnerId),
    onReject: onCloseModal,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.testResults.personalization.mabEndTestModal.rejectLabel"
    }),
    use: "danger"
  });
};
const mabInteractionTracker = pageType => (action, status) => usageTracker.track('mabInteraction', {
  action,
  pageType,
  status
});
const MABEndTest = ({
  variationsList,
  mabExperiment
}) => {
  const [showMABEndTestModal, setShowMABEndTestModal] = useState(false);
  const [isMABEndTestLoading, setIsMABEndTestLoading] = useState(false);
  const {
    contentObjectType
  } = useContentObjectType();
  const trackMABInteraction = mabInteractionTracker(contentObjectType);
  const onEndTest = winnerId => {
    setIsMABEndTestLoading(true);
    trackMABInteraction('clicked-end-test-button');
    requestEndMABTest({
      mabExperimentId: mabExperiment.id,
      winnerId,
      contentObjectType
    }).then(({
      id
    }) => {
      trackMABInteraction('end-test', 'success');
      const url = getDetailsUrl({
        contentObjectType,
        id
      });
      window.location.href = url;
    }).catch(() => {
      setIsMABEndTestLoading(false);
      trackMABInteraction('end-test', 'fail');
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.testResults.personalization.mabEndTestModal.error.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.testResults.personalization.mabEndTestModal.error.title"
        }),
        type: 'danger'
      });
    });
  };
  if (variationsList.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, {
      onClick: () => setShowMABEndTestModal(true),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.testResults.personalization.mabEndTest.url"
      })
    }), showMABEndTestModal && /*#__PURE__*/_jsx(MABEndTestModal, {
      mabMetric: mabExperiment.metric,
      variationsList: variationsList,
      onCloseModal: () => setShowMABEndTestModal(false),
      onEndTest: onEndTest,
      isMABEndTestLoading: isMABEndTestLoading
    })]
  });
};
export default MABEndTest;